import React from 'react';
import { Badge, Tag } from 'antd';
import { 
    ClockCircleOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ReloadOutlined
} from '@ant-design/icons';

/**
 * 批次状态徽章组件
 * 统一的状态展示样式
 */
const BatchStatusBadge = ({ status, showIcon = true, size = 'default' }) => {
    // 批次状态配置
    const STATUS_CONFIG = {
        PENDING: {
            label: '待处理',
            badgeStatus: 'default',
            tagColor: 'default',
            icon: <ClockCircleOutlined />
        },
        RUNNING: {
            label: '运行中',
            badgeStatus: 'processing',
            tagColor: 'processing',
            icon: <SyncOutlined spin />
        },
        COMPLETED: {
            label: '已完成',
            badgeStatus: 'success',
            tagColor: 'success',
            icon: <CheckCircleOutlined />
        },
        FAILED: {
            label: '失败',
            badgeStatus: 'error',
            tagColor: 'error',
            icon: <CloseCircleOutlined />
        },
        NEEDS_RECALCULATION: {
            label: '需要重新计算',
            badgeStatus: 'warning',
            tagColor: 'warning',
            icon: <ReloadOutlined />
        }
    };

    const config = STATUS_CONFIG[status] || STATUS_CONFIG.PENDING;

    // 如果是小尺寸，使用Badge
    if (size === 'small') {
        return (
            <Badge 
                status={config.badgeStatus} 
                text={config.label} 
            />
        );
    }

    // 否则使用Tag
    return (
        <Tag 
            icon={showIcon ? config.icon : null}
            color={config.tagColor}
        >
            {config.label}
        </Tag>
    );
};

/**
 * 批次类型Tag组件
 */
export const BatchTypeTag = ({ type }) => {
    const TYPE_CONFIG = {
        OFFICIAL: { label: '正式', color: 'green' },
        DRAFT: { label: '草稿', color: 'blue' },
        ADJUSTMENT: { label: '调整', color: 'orange' },
        TEST: { label: '测试', color: 'default' }
    };

    const config = TYPE_CONFIG[type] || { label: type, color: 'default' };

    return <Tag color={config.color}>{config.label}</Tag>;
};

export default BatchStatusBadge;

